import React from 'react';
import { styled } from '@staffino/primitive-controls';
import { layout } from 'styled-system';

const StyledLabel = styled.label<{ width }>((props) => ({
  cursor: 'pointer',
  marginTop: '15px',
  transition: 'margin 0.3s ease',
  'input:checked + &': {
    opacity: 1,
  },
  '&:hover': {
    marginTop: '0px',
  },
  '& img': {
    pointerEvents: 'none',
  },
  marginLeft: '2px',
  marginRight: '2px',
  maxHeight: '5.625rem',
  maxWidth: '5.625rem',
  width: props.width,
  height: 'auto',
}));

const HiddenRadio = styled.input({
  position: 'absolute',
  width: 0,
  height: 0,
  opacity: 0,
});

const Image = styled.img(layout);

export default function EmoticonButton({
  score,
  width,
  name,
  innerRef,
  imageUrl,
  onChange,
}) {
  return (
    <>
      <HiddenRadio
        ref={innerRef}
        type="radio"
        name={name}
        defaultValue={score}
        id={`${name}.${score}`}
        onChange={() => onChange?.(score)}
      />
      <StyledLabel htmlFor={`${name}.${score}`} width={width}>
        <Image className="normal" src={imageUrl} width="100%" />
      </StyledLabel>
    </>
  );
}
